import { render } from "./DocDisplay.vue?vue&type=template&id=86cfcc28&scoped=true"
import script from "./DocDisplay.vue?vue&type=script&lang=js"
export * from "./DocDisplay.vue?vue&type=script&lang=js"

import "./DocDisplay.vue?vue&type=style&index=0&id=86cfcc28&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86cfcc28"]])

export default __exports__